import Vue from 'vue'

import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

import variables from '@/styles/abstracts/_colors.module.scss'
export const options = {
  rtl: false,
  breakpoint: {
    thresholds: {
      xs: 515,
      sm: 768,
      md: 992,
      lg: 1280,
    },
    scrollBarWidth: 10,
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        ...variables,
        primary: variables.primary,
        secondary: variables.secondary,
        accent: variables.accent,
        error: variables.error,
        info: variables.info,
        success: variables.success,
        warning: variables.warning,
      },
    },
  },
}

Vuetify.config.silent = true

export default new Vuetify(options)
